<div mat-dialog-content>
    <div class="mat-dialog-content">
        <div class="title-header">
            <h1>Visualizar registro</h1>
        </div>

        <div class="body-modal" *ngIf="formattedRequestJson">
            <div class="col-12 col-md-4">
                <h1><span>Solicitação</span></h1>
            </div>
            <mat-form-field appearance="outline">
                <textarea matInput readonly [rows]="10">{{ formattedRequestJson }}</textarea>
            </mat-form-field>
        </div>
        <div class="body-modal" *ngIf="formattedResponseJson">
            <div class="col-12 col-md-4">
                <h1><span>Resposta</span></h1>
            </div>
            <mat-form-field appearance="outline">
                <textarea matInput readonly [rows]="10">{{ formattedResponseJson }}</textarea>
            </mat-form-field>
        </div>

        <div class="btn-container">
            <button mat-flat-button color="primary" class="btn-primary block" (click)="back()">Voltar</button>
        </div>
    </div>
</div>